import { DateTime, Duration } from "luxon";

export type DatetimesWithOffset = {
  datetimeFrom: string | null;
  datetimeFromOffset: string | null;
  datetimeTo: string | null;
  datetimeToOffset: string | null;
};

export type TimeRange = {
  start: string | null;
  end: string | null;
};

export const getPlotTimeRange = (referenceTime: string, plotTime?: DatetimesWithOffset): TimeRange => {
  if (plotTime?.datetimeToOffset && plotTime?.datetimeFromOffset) {
    return {
      start: DateTime.fromISO(referenceTime).plus(Duration.fromISO(plotTime.datetimeFromOffset)).toISO(),
      end: DateTime.fromISO(referenceTime).plus(Duration.fromISO(plotTime.datetimeToOffset)).toISO(),
    };
  }
  return {
    start: plotTime?.datetimeFrom || null,
    end: plotTime?.datetimeTo || null,
  };
};

export const getPlotTimeRangeDeprecated = (
  referenceTime: string,
  plot?: {
    datetime_from?: string | null;
    datetime_to?: string | null;
    datetime_from_offset?: string | null;
    datetime_to_offset?: string | null;
  },
): TimeRange => {
  if (plot?.datetime_to_offset && plot?.datetime_from_offset) {
    return {
      start: DateTime.fromISO(referenceTime).plus(Duration.fromISO(plot.datetime_from_offset)).toISO(),
      end: DateTime.fromISO(referenceTime).plus(Duration.fromISO(plot.datetime_to_offset)).toISO(),
    };
  }
  return {
    start: plot?.datetime_from || null,
    end: plot?.datetime_to || null,
  };
};

export const getTimeRangeWithOffset = (referenceTime: string, datetimes: DatetimesWithOffset): TimeRange => {
  if (datetimes.datetimeToOffset && datetimes.datetimeFromOffset) {
    return {
      start: DateTime.fromISO(referenceTime).plus(Duration.fromISO(datetimes.datetimeFromOffset)).toISO(),
      end: DateTime.fromISO(referenceTime).plus(Duration.fromISO(datetimes.datetimeToOffset)).toISO(),
    };
  }
  return {
    start: datetimes.datetimeFrom || null,
    end: datetimes.datetimeTo || null,
  };
};
